"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../../graphql");
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../hooks");
exports.DeployButton = ({ emailTemplateVersion, emailTemplate: emailTemplateOriginal, onCompleted, }) => {
    var _a, _b, _c, _d, _e, _f;
    const queryResult = react_hooks_1.useQuery(graphql_1.emailTemplate, {
        // fetchPolicy: 'cache-only',
        skip: !emailTemplateOriginal ||
            !emailTemplateOriginal.id ||
            isNaN(emailTemplateOriginal && emailTemplateOriginal.id),
        variables: {
            id: emailTemplateOriginal && emailTemplateOriginal.id,
        },
    });
    const deployedToProduction = ((_c = (_b = (_a = queryResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.emailTemplate) === null || _c === void 0 ? void 0 : _c.productionVersion) &&
        queryResult.data.emailTemplate.productionVersion.id ===
            emailTemplateVersion.id;
    const deployedToStaging = ((_f = (_e = (_d = queryResult) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.emailTemplate) === null || _f === void 0 ? void 0 : _f.stagingVersion) &&
        queryResult.data.emailTemplate.stagingVersion.id ===
            emailTemplateVersion.id;
    const { mutate, mutationResult, } = hooks_1.useDeployEmailTemplateVersion(emailTemplateVersion, deployedToProduction || deployedToStaging ? 'production' : 'staging', { onCompleted });
    return (react_1.default.createElement(react_2.OsmosysButton, { osysName: "DeployButton", size: "sm", color: deployedToProduction
            ? 'primary'
            : deployedToStaging
                ? 'light'
                : 'warning', mutationResult: mutationResult, mutate: mutate, osysIcon: deployedToProduction ? 'success' : 'deploy', disabled: deployedToProduction, renderApolloError: true, preventDefault: true }, deployedToProduction
        ? 'Deployed to Production'
        : deployedToStaging
            ? 'Deploy to Production'
            : 'Deploy to Staging'));
};
//# sourceMappingURL=DeployButton.js.map